module.exports = __webpack_public_path__ + "img/ring.0f935dd5.png";